module.exports = __webpack_public_path__ + "img/block6-card11.9f724f8c.svg";